
import CircleFillIcon from '~/assets/images/circle-fill-icon.svg?inline'
import { Image } from 'vue-datocms'
import PageStats from '~/components/public/page/page-stats.vue'

export default {
  components: {
    CircleFillIcon,
    'datocms-image': Image,
    PageStats,
  },
  props: {
    // Required
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    stats: {
      type: Array,
      default: () => [],
    },

    // Optional
    orientation: {
      type: String,
      default: 'vertical',
      validator: (value) =>
        ['vertical', 'horizontal'].includes(value.toLowerCase()),
    },
  },

  computed: {
    orientationClass() {
      return `orientation-${this.orientation}`
    },
  },
}
